<template>
  <div class="ty-main">
    <div class="ty-content white">
    <el-form :inline="true" :model="form" class="query-form" @submit.native.prevent>
        <!-- <el-form-item label="操作员工">
        <el-input
          v-model="form.searchName"
          placeholder="请选择员工"
          @focus="openSelectDialog"
          clearable
          @clear="setValueNull"
        ></el-input>
          <el-select v-model="form.searchName" @focus="openSelectDialog" @clear="setValueNull" clearable multiple placeholder="请选择员工">
            <el-option
              v-for="item in arr"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="">
          <el-autocomplete
          :placeholder="placeholder"
          v-model="form.searchName"
          :fetch-suggestions="querySearch"
          value-key="name"
          @focus="openSelectDialog"
          @clear="setValueNull"
          @input="inquire"
          @select="handleSelect"
          :trigger-on-focus="false"
          :clearable="clearable"
          class="input-with-select" >
              <el-select v-model="form.select" @change="sdhu" slot="prepend" placeholder="请选择" style="width: 130px;">
                <el-option
                  v-for="item in staff"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  clearable />
              </el-select>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="部门:">
        <el-input
          v-model="form.department_id"
          placeholder="请选择部门"
          @focus="departmentShow2"
          clearable
          @clear="employeeClear"
        ></el-input>
        </el-form-item>
        <el-form-item label="删除时间:">
          <el-date-picker
            v-model="form.scopeDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            :default-value="Date.now() - 30 * 24 * 3600 * 1000"
            >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="风险等级:">
            <el-select v-model="form.share_status" placeholder="">
                <el-option
                v-for="item in grade"
                :key="item.share_status"
                :label="item.label"
                :value="item.share_status">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="dsfdi" type="primary" @click="onSearch">查询</el-button>
        </el-form-item>
        <el-button class="fr" :disabled="dqweqweq" type="primary" size="medium" @click="nunExport"
          >导出列表</el-button
        >
      </el-form>
      <el-table :data="tableData" style="width: 100%;">
        <el-table-column label="操作员工" fixed width="280">
          <template slot-scope="scope">
            <div v-if="scope.row.staff_data.status === 0"><span>未知员工</span></div>
            <div v-else>
              <el-popover
                v-if="scope.row.staff_data.name.length > 10"
                placement="top-start"
                popper-class="popperBox"
                trigger="hover">
                <span>{{scope.row.staff_data.name}} <span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
                  <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
                  <span class="tag" v-if="scope.row.new_user_status === -1">离职</span></span>
                <span slot="reference" style="color: #303133;">{{scope.row.staff_data.name | ellipsis}}
                  <span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
                  <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
                  <span class="tag" v-if="scope.row.new_user_status === -1">离职</span>
                </span>
              </el-popover>
              <span v-else>
                <span>{{ scope.row.staff_data.name }}</span>
                <span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
                <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
                <span class="tag" v-if="scope.row.new_user_status === -1">离职</span></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="部门" width="254">
          <template slot-scope="scope">
            <div v-if="scope.row.staff_data.department_name.length > 0">
              <el-popover
                v-if="scope.row.staff_data.department_name.length > 16"
                placement="top-start"
                popper-class="popperBox"
                trigger="hover">
                <div>{{scope.row.staff_data.department_name}}</div>
                <span slot="reference" style="color: #303133;">{{scope.row.staff_data.department_name | ellipsiss}}</span>
              </el-popover>
              <span v-else>{{scope.row.staff_data.department_name}}</span>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="被删客户" width="334">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.customer_data.name && scope.row.customer_data.name.length >= 10"
              placement="top-start"
              popper-class="popperBox"
              trigger="hover">
                <span>{{ scope.row.customer_data.name}}</span>
                <span class="biao01" v-if="scope.row.customer_data.type === 1">@微信</span>
                <span class="qian01" v-else-if="scope.row.customer_data.type === 2">@{{ scope.row.customer_data.corp_name }}</span>
              <span slot="reference" style="color: #303133;">
                <div style="display: flex;">
                  <img class="img" :src="scope.row.customer_data.avatar">
                  <div class="zi">
                    <span>{{ scope.row.customer_data.name | ellipsis}}</span>
                  </div>
                  <div>
                    <span class="biao" v-if="scope.row.customer_data.type === 1">@微信</span>
                    <span class="qian" v-else-if="scope.row.customer_data.type === 2">@{{ scope.row.customer_data.corp_name.slice(0, 6) + '...' }}</span>
                  </div>
                </div>
              </span>
            </el-popover>
            <div v-else-if="scope.row.customer_data.name && scope.row.customer_data.name.length < 10" style="display: flex;">
              <img class="img" v-if="scope.row.customer_data.avatar" :src="scope.row.customer_data.avatar">
              <img class="img" v-else src="../../../assets/images/user_avatar2.png">
              <div class="zi">
                <span v-if="scope.row.customer_data.name">{{ scope.row.customer_data.name | ellipsiss}}</span>
                <span v-else>陌生人</span>
              </div>
              <div>
                <span class="biao" v-if="scope.row.customer_data.type === 1">@微信</span>
                <span class="qian" v-else-if="scope.row.customer_data.type === 2">@{{ scope.row.customer_data.corp_name }}</span>
              </div>
            </div>
            <div v-if="scope.row.customer_data.length === 0" style="display: flex;">
              <img class="img" src="../../../assets/images/user_avatar2.png">
                <div class="zi">陌生人</div>
              </div>
          </template>
        </el-table-column>
        <el-table-column label="删除时间" min-width="180">
           <template slot-scope="scope">
            <span>{{scope.row.invalid_time ? scope.row.invalid_time : '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="150">
        <template slot="header">
            风险等级
            <el-tooltip
              class="item"
              effect="dark"
              placement="top-start"
            >
            <div slot="content">一级为员工删除客户<br/>二级为客户删除员工后，员工再将客户删除</div>
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <span v-if="scope.row.risk_level !== ''">
              <span v-if="scope.row.risk_level === 0">未知</span>
              <span v-else-if="scope.row.risk_level === 1">一级</span>
              <span v-else>二级</span>
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="180">
          <template slot-scope="scope">
            <el-button
              type="text"
              v-auth="['operationLogDetails']"
              @click="openDetailDialog(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
          <template #empty>
            <el-empty v-loading="loading">
          </el-empty>
        </template>
      </el-table>
      <div class="toolbar">
        <div></div>
        <el-pagination
          background
          @current-change="currentChange"
          :current-page="currentPage"
          :page-size="pagesize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 选择员工 -->
    <el-dialog title="选择员工" :visible.sync="isSelectDialog" :show-close="false" :close-on-click-modal="false" width="600px" @open="clear">
      <el-row>
        <el-col :span="12">
          <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never" style="border-right: 1px solid #D8DCE1;">
            <el-input
              class="filter-input"
              placeholder="请输入人员名称"
              v-model="filterText"
              size="small"
              @input="dfhuh"
              @clear="gdfgf"
              clearable
            >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <div v-if="treeData01.length > 0 && treeData02.length === 0">
            <el-tree
              ref="tree"
              id="fixtree"
              :props="defaultProps"
              node-key="value"
              :check-on-click-node="true"
              :load="loadNode"
              :filter-node-method="filterNode"
              auto-expand-parent
              :check-strictly="true"
              :default-checked-keys="peoples"
              lazy
              @check-change="getChecked">
              <span class="custom-tree-node" slot-scope="{ data, node }">
                  <span v-if="data.isDepartment === false">
                    <img class="organization-img imgleft" src="../../../assets/images/zuzhi.png" style="width:14px;height:14px;" alt="">
                    <span v-if="data.is_show === true" style="color: #9D9D9D;">{{ data.label }}</span>
                    <span v-if="data.is_show === false">{{ data.label }}</span>
                  </span>
                  <span v-if="data.isDepartment === true">
                    <img v-if="data.label" class="organization-img" src="../../../assets/images/user.png" style="width:14px;height:14px;" alt="">
                    {{ data.label }}<span
                      v-if="node.checked && data.label"
                      style="margin-left: 10px;"
                      class="el-icon-check"
                    ></span>
                  </span>
                </span>
            </el-tree>
            </div>
            <ul class="infinite-lists" v-if="treeData02.length > 0" styel="z-index: 999;">
              <li v-for="(item, index) in treeData02" :key="index" @click="getChecked(item)" style="margin-left: -40px;text-align:left;margin-top:10px;">
                  <img class="organization-img" src="../../../assets/images/user.png" style="width:14px;height:14px;" alt="">
                  <span style="margin-left:15px;">{{ item.label }} - {{ item.department_name}}</span>
              </li>
            </ul>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never">
            <div>已选择的员工</div>
             <ul class="infinite-list">
              <li v-for="item in checkedDimission" :key="item.id">
                <img class="organization-img" src="../../../assets/images/user.png" style="width:14px;height:14px;" alt="">
                <div :class="item.name.length <= 20 ? 'wqeq' : 'gfdgd'">{{ item.name }}</div>
                <div class="uiwe">
                  <i class="el-icon-close" @click="employeeClose(item)"></i>
               </div>
              </li>
          </ul>
          </el-card>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="closee">取消</el-button>
        <el-button style="width: 72px;" type="primary" :disabled="disabled01" @click="reLoadTable">确定</el-button>
      </span>
    </el-dialog>
    <!-- 选择部门 -->
    <el-dialog title="选择部门" :visible.sync="departmentShow" :show-close="false" :close-on-click-modal="false" width="600px">
      <el-row>
        <el-col :span="12" style="border-right: 1px solid rgba(216, 220, 225, 0.39);">
          <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never">
            <el-input
              class="filter-input"
              placeholder="搜索部门"
              prefix-icon="el-icon-search"
              v-model="filterTitle"
              size="small"
              clearable
            >
            </el-input>
            <el-tree
              ref="treeDepartment"
              :data="departmentData"
              node-key="value"
              :props="departmentProps"
              :check-on-click-node="true"
              :default-expanded-keys="departs"
              :default-checked-keys="departs"
              @check-change="getDepart"
              :filter-node-method="filterDepart"
              :check-strictly="true"
            >
            <span class="custom-tree-node" slot-scope="{ node }">
              <span>
                <img class="organization-img" src="../../../assets/images/zuzhi.png" style="width:14px;height:14px;" alt="">
                {{ node.label }}<span
                      v-if="node.checked"
                      style="margin-left: 10px;"
                      class="el-icon-check"
                    ></span>
              </span>
            </span>
            </el-tree>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never">
            <div class="xuanze">已选择的部门</div>
            <ul class="infinite-list">
              <li class="weqw"
              v-for="item in checkedDepartment"
              :key="item.id">
                <img src="../../../assets/images/zuzhi.png" style="width:14px;height:14px;" alt="">
                <div :class="item.label.length <= 20 ? 'wq' : 'wq01'">{{ item.label }}</div>
                <i class="el-icon-close" @click="empClose(item)"></i>
              </li>
            </ul>
          </el-card>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="closeDepart">取消</el-button>
        <el-button style="width: 72px;" type="primary" :disabled="disabled2"  @click="reLoadDepart">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="对话详情" :visible.sync="dialogVisible" width="650px" :show-close="true" @close="close01">
      <div class="more" v-if="msgId !== ''" style="padding-left: 10px;padding-right: 30px;margin-bottom: 20px;">
        <template>
          <chat :msgId="msgId"></chat>
        </template>
      </div>
      <div class="content" v-else>暂无数据</div>
    </el-dialog>
  </div>
</template>
<script>
// import Department from '../components/department'
import chat from '../../../components/chat'
import { apiUrl } from '../../../config/constant'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import { ellipsis, ellipsissss } from '../../../utils/filters.js'
export default {
  components: {
  //  Department,
    chat
  },
  props: {
    staffId: {
      type: String
    },
    statu: {
      type: String
    },
    name: {
      type: String
    }
  },
  data() {
    return {
      apiUrl,
      ellipsis,
      ellipsissss,
      currentPage: 1,
      pagesize: 10,
      placeholder: '请选择在职员工',
      treeData01: [],
      treeData02: [],
      loading: false,
      filterText: '',
      filterTitle: '',
      dqweqweq: true,
      total: 0,
      departmentShow: false,
      checkedDepartment: [],
      departmentData: [],
      depapart_id: [],
      disabled2: true,
      trigger: true,
      clearable: false,
      departs: [],
      departmentProps: {
        children: 'child',
        label: 'label',
        value: 'value'
      },
      r: '',
      arr: [],
      disabled01: true,
      pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now()
          }
      },
      tableData: [],
      user_name: '',
      checkedDimission: [],
      isSelectDialog: false,
      isDepartmentDialog: false,
      form: {
        searchName: '',
        department_id: '',
        scopeDate: '',
        select: '1',
        share_status: '0'
      },
      msgId: '',
      searchIds: [],
      dialogVisible: false,
      defaultProps: {
        children: 'children',
        label: 'label',
        value: 'value',
        isLeaf: 'isHasChildren'
      },
      value: '1',
      grade: [{
        share_status: '0',
        label: '全部'
      }, {
        share_status: '1',
        label: '一级'
      }, {
        share_status: '2',
        label: '二级'
      }],
      staff: [{
        value: '1',
        label: '在职员工:'
      }, {
        value: '2',
        label: '离职员工:'
      }],
      peoples: []
    }
  },
  mounted() {
    this.ojfdsa()
    this.getList()
    this.getLeaveStaff()
    this.sfhusi()
    this.getDepartment()
  },
  watch: {
    filterText(val) {
      if (val) {
        this.$refs.tree.filter(val)
      } else {
        this.treeData01 = []
        this.parent_id = 0
        this.sfhusi()
      }
    },
    filterTitle(val) {
      if (val) {
        this.$refs.treeDepartment.filter(val)
      }
    },
    checkedDimission(val) {
      if (val.length > 0) {
        this.disabled01 = false
      } else {
        this.disabled01 = true
      }
    },
    checkedDepartment(val) {
      if (val.length > 0) {
        this.disabled2 = false
      } else {
        this.disabled2 = true
      }
    }
  },
  methods: {
     loadNode(node, resolve) {
      if (node === undefined || node.level === 0) {
        this.chooseNode = node
        resolve(this.treeData01)
      } else {
        this.parent_id = node.data.value
        this.getChildrenNode()
        setTimeout(() => {
          resolve(this.treeData01)
        }, 1200)
      }
    },
    // 一级
    sfhusi() {
      this.$api.post('/api/v1/test/get-department', {
        user_id: sessionStorage.getItem('user_id'),
        parent_id: this.parent_id
      }).then(res => {
        this.chooseNode = 0
        this.treeData01 = res.return_data
      })
    },
    // 二级
    getChildrenNode() {
      this.$api.post('/api/v1/test/get-department', {
        user_id: sessionStorage.getItem('user_id'),
        parent_id: this.parent_id
      }).then(res => {
        if (res.return_data.length === 0) {
          res.return_data = [{ isDepartment: true }]
          this.treeData01 = res.return_data
        } else {
          this.chooseNode = 0
          this.treeData01 = res.return_data
        }
      })
    },
    sdhu(item) {
        if (item === '2') {
          this.placeholder = '请输入离职员工'
          this.form.searchName = ''
          this.searchIds = []
          this.user_name = ''
        } else {
            this.placeholder = '请选择在职员工'
            this.form.searchName = ''
            this.searchIds = []
            this.user_name = ''
        }
    },
    employeeClose(value) {
      this.checkedDimission.forEach((item, i) => {
        if (item.id === value.id) {
          if (value.show) {
            this.checkedDimission.splice(i, 1)
          } else {
            this.checkedDimission.splice(i, 1)
            this.$refs.tree.setChecked(value.id, false, true)
          }
        }
      })
    },
    // 获取离职员工
    getLeaveStaff(name) {
      this.$api
        .get('/api/system/get/quit/staff', {
          name: name
        })
        .then(res => {
          const list = []
          res.forEach(v => {
            list.push({
              name: v.name + '~' + v.department_name
            })
          })
          this.leaveAllList = res
        })
    },
    close() {
      this.isSelectDialog = false
      this.treeData01 = []
      this.treeData01 = []
      this.treeData02 = []
      this.checkedDimission = []
      this.parent_id = 0
      this.sfhusi()
      this.getList()
    },
    ojfdsa() {
      this.form.searchName = this.name
      if (this.statu === 5) {
        this.form.select = 2
      }
    },
    getChecked(value, isCheck) {
      if (value.isDepartment === true && value.value) {
        const checkedDimission = this.checkedDimission
        if (isCheck === false) {
          checkedDimission.forEach((item, i) => {
            if (item.id === value.value) {
              checkedDimission.splice(i, 1)
            }
          })
          return false
        }
        checkedDimission.forEach((item, i) => {
          if (item.id === value.value) {
            checkedDimission.splice(i, 1)
          }
        })
        if (value.department_name) {
           checkedDimission.push({
            id: value.value,
            name: value.label,
            show: 'false'
          })
        } else {
          checkedDimission.push({
            id: value.value,
            name: value.label
          })
        }
        this.checkedDimission = checkedDimission
      } else {
        this.checkedDimission.forEach(v => {
          this.peoples.push(v.id)
        })
        return false
      }
    },
    reLoadTable() {
      const q = []
      if (this.checkedDimission.length > 0) {
          this.checkedDimission.forEach(v => {
            q.push(v.name)
            this.searchIds.push(v.id)
        })
        this.form.searchName = q.toString()
        this.currentPage = 1
        this.getList()
        this.isSelectDialog = false
      } else {
        this.$message.warning('请选择员工')
      }
    },
    close01() {
      this.msgId = ''
    },
    openSelectDialog() {
      this.staffId = ''
      this.statu = ''
      this.name = ''
      this.searchIds = []
      if (this.form.select === '1') {
          this.isSelectDialog = true
          this.form.searchName = ''
          this.arr = []
          // this.getlistAll()
          this.trigger = false
          this.clearable = true
      } else if (this.form.select === '2') {
        this.user_name = ''
        this.isSelectDialog = false
        this.trigger = true
        this.clearable = false
      }
    },
    querySearch(queryString, cb) {
      var restaurants = this.leaveAllList
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      setTimeout(() => {
          cb(results)
        }, 3000)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    inquire() {
      this.treeData01 = []
      this.parent_id = 0
      this.sfhusi()
      this.queryString = this.form.searchName
      this.querySearch()
    },
    handleSelect(item) {
      this.user_name = item.name
    },
    setValueNull() {
      this.id = []
      this.searchIds = []
      this.filterText = ''
      this.treeData01 = []
      this.treeData02 = []
      this.checkedDimission = []
      this.parent_id = 0
      this.sfhusi()
      this.getList()
    },
    // tree过滤
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    // getlistAll() {
    //   this.loading01 = true
    //   const params = {
    //     page: 1,
    //     limit: 15
    //   }
    //   this.$api.get('/api/v1/inherit/get-department-user', params).then(response => {
    //     let res = response
    //     if (response && typeof response === 'string') {
    //       res = JSON.parse(response)
    //     }

    //     const treeData01 = res || []
    //     treeData01.forEach(v => {
    //       v.checkTitle = v.name
    //       v.id = v.user_id
    //     })
    //     this.treeData01 = treeData01 || []
    //     this.loading01 = false
    //   })
    // },
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getList()
    },
    getList() {
      this.loading = true
      this.dqweqweq = true
      this.tableData = []
      const { scopeDate } = this.form
      let scopeTime = {}
      if (scopeDate && scopeDate.length) {
        scopeTime = {
          start_time: this.$moment(new Date(scopeDate[0])).format('YYYY-MM-DD 00:00:00'),
          end_time: this.$moment(new Date(scopeDate[1])).format('YYYY-MM-DD 23:59:59')
        }
      }
      if (this.staffId || this.staffId !== '') {
        this.searchIds.push(this.staffId)
      }
      this.$api.post('/api/system/sensitive/index', {
          page: this.currentPage,
          user_id: this.searchIds,
          user_name: this.user_name,
          department_id: this.depapart_id,
          start_time: scopeTime.start_time,
          risk_level: this.form.share_status,
          end_time: scopeTime.end_time
        })
        .then(res => {
          const tableData = res.data
          this.total = res.total
          this.tableData = tableData
          this.loading = false
          this.dqweqweq = false
        })
    },
    currentChange(val) {
      this.currentPage = val
      this.getList()
    },
    openDetailDialog(row) {
      if (row.msg_id === '') {
        this.dialogVisible = true
        // this.$message.warning('该员工和客户没有聊天记录')
        return false
      } else {
      this.dialogVisible = true
      this.msgId = row.msg_id
      // this.$api
      //   .post('/api/system/search/content/audit/details', {
      //     msg_id: row.msg_id,
      //     is_surplus: 1,
      //     type: 1,
      //     page: 1
      //   })
      //   .then(async res => {
      //     setTimeout(() => {
      //       this.dialogVisible = true
      //       this.msgId = row.msg_id
      //     }, 200)
      //   })
      }
    },
    departmentShow2() {
      this.depapart_id = []
      this.departmentShow = true
    },
    // 获取部门表
    getDepartment() {
      this.$api.get('/api/v1/inherit/get-department', {
        user_id: sessionStorage.getItem('user_id')
      }).then(response => {
        let arr = []
        arr = response.data
        this.departmentData = arr || []
      })
    },
    empClose(value) {
      this.$refs.treeDepartment.setChecked(value.value, false)
    },
    getDepart(value, isCheck) {
       const checkedDepartment = this.checkedDepartment
      if (isCheck) {
        checkedDepartment.push({
          label: value.label,
          value: value.value
        })
      } else {
        checkedDepartment.forEach((item, i) => {
          if (item.value === value.value) {
            checkedDepartment.splice(i, 1)
          }
        })
      }
      this.checkedDepartment = checkedDepartment
      this.checkedDepartment.forEach(k => {
        this.departs.push(k.id)
      })
    },
    closee() {
      this.isSelectDialog = false
      this.filterText = ''
      this.treeData02 = []
      this.treeData01 = []
      this.peoples = []
      this.checkedDimission = []
      this.parent_id = 0
      this.sfhusi()
      this.getList()
    },
    gdfgf() {
      this.filterText = ''
      // this.treeData01 = []
      // this.sfhusi()
    },
    reLoadDepart() {
      const l = []
      if (this.checkedDepartment.length > 0) {
        this.checkedDepartment.forEach(v => {
          l.push(v.label)
          this.depapart_id.push(v.value)
        })
        this.form.department_id = l.toString()
        this.currentPage = 1
        this.departmentShow = false
        this.getList()
      } else {
        this.$message.warning('请先选择部门')
      }
    },
    closeDepart() {
      this.form.department_id = ''
      this.departmentShow = false
      this.filterTitle = ''
      this.getDepartment()
      // this.departmentData = []
      this.checkedDepartment = []
    },
    filterDepart(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    employeeClear() {
      this.id = ''
      this.depapart_id = []
      this.filterText = ''
      this.getDepartment()
      this.getList()
    },
    // 敏感词数量导出
    nunExport() {
      // window.location.href = 'http://chatdata.test.api.tyunai.cn/api/sensitive/index/excel'
      const { scopeDate } = this.form
      let scopeTime = {}
      if (scopeDate && scopeDate.length) {
        scopeTime = {
          start_time: this.$moment(new Date(scopeDate[0])).format('YYYY-MM-DD 00:00:00'),
          end_time: this.$moment(new Date(scopeDate[1])).format('YYYY-MM-DD 23:59:59')
        }
      }
      if (this.staffId || this.staffId !== '') {
        this.searchIds.push(this.staffId)
      }
      this.$api.get('/api/sensitive/index/excel', {
          page: this.currentPage,
          user_id: this.searchIds,
          user_name: this.user_name,
          department_id: this.depapart_id,
          start_time: scopeTime.start_time,
          risk_level: this.form.share_status,
          end_time: scopeTime.end_time
        })
        .then(res => {
          this.$message({
            message: '导出的文件请到菜单栏中的【下载中心】去下载',
            type: 'success'
          })
          // window.open(apiUrl + res)
        })
    },
    dfhuh() {
      // this.treeData01 = []
      this.$api.post('/api/v1/test/get-user-department', {
        user_id: sessionStorage.getItem('user_id'),
        name: this.filterText
      })
      .then(res => {
        if (res.length === 0 || res.user_data.length === 0) {
          this.treeData02 = []
        } else {
          this.treeData02 = res.user_data
        }
      })
    },
    clear() {
      this.parent_id = 0
    }
  }
}
</script>
<style lang="scss" scoped>
.el-card{
  overflow:auto;
  box-shadow: none;
}
::v-deep .el-dialog .el-dialog__footer{
  text-align:right;
}
::v-deep .el-dialog__body{
  padding: 0;
}
.content{
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.img{
    width:32px;
    height:32px;
    border-radius: 2px;
    border: 1px solid #204A9E;
  }
.zi{
  margin-left: 16px;
  line-height: 35px;

}
.biao{
  margin-left:5px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 35px;
  color: #46BB36;
  opacity: 1;
}
.qian{
  margin-left:5px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 35px;
  color: #FFC811;
  opacity: 1;
}
.biao01{
  margin-left:5px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #46BB36;
  opacity: 1;
}
.qian01{
  margin-left:5px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #FFC811;
  opacity: 1;
}
::v-deep.ty-cont{
  height: auto;
}
::v-deep.el-form-item{
  margin-bottom: 0;
}
::v-deep .el-dialog__header {
    background: #FFFFFF;
    opacity: 1;
    border-radius: 2p;
}
::v-deep .el-radio-button__inner{
  border:1px solid #204a9e;
  color:#204a9e;
}
::v-deep .el-select .el-tag__close.el-icon-close{
  display: none;
}
::v-deep .el-table td .el-button:hover{
  border: none;
}
::v-deep .input-with-select .el-input-group__prepend {
    background-color: #fff;
    color: #303133;
    font-size: 16px;
    border: none;
  }
//   ::v-deep .input-with-select .el-input-group__prepend:focus {
//     background-color: #fff;
//   }
//   ::v-deep .input-with-select .el-input-group__prepend:hover {
//     background-color: #fff;
//   }
::v-deep .el-input-group--prepend .el-input__inner:hover{
  border-color: #234C9C;
}
.mb2001{
  position: relative;
  top: 2%;
  text-align: center;
}
::v-deep .el-button--primary.is-disabled{
  background-color: #3974C7;
}
.el-button--primary.is-disabled{
  opacity: 0.7;
}
.filter-input {
  margin-bottom: 8px;
  line-height: 34px;
}
::v-deep .el-autocomplete{
  line-height: 40px;
}
::v-deep .el-input-group__prepend{
  padding-left: 5px;
}
.fr{
  margin-bottom: 20px;
}
</style>
